import { alpha, borderTop, height, width } from "@mui/system";

const styles = (theme) => ({
  paperFluxo: {
    display: "flex",
    flexDirection: "column",
    position: "relative",
    backgroundColor: theme.palette.background.paper,
    pt: 1,
    pl: 1,
    pr: 1,
    display: "flex",
    gap: 1,
  },
  containerPaper: {
    borderRadius: "16px",
    backgroundColor:
      theme.palette.mode === "dark"
        ? alpha(theme.palette.colors.black.dark, 0.4)
        : theme.palette.colors.black.lighter,
    my: 5,
    mx: 3,
    mb: 2,
  },
  title: {
    fontWeight: 700,
    fontSize: 16,
  },
  paperCard: {
    borderRadius: "16px",
    padding: 3,
    display: "flex",
    flexDirection: "column",
    gap: 2,
    position: "relative",
    overflow: "visible",
    minHeight: "150px",
    borderRadius: "25px",
    borderTop: "10px solid",
    px: 1,
    py: 2,
    height: "100%",
  },
  chipContained: {
    position: "absolute",
    top: -10,
    left: -1,
    minWidth: "40px",
    height: "25px",
    padding: 1,
    borderTopLeftRadius: "16px",
    borderBottomRightRadius: "16px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: 0.5,
  },
  nameChip: {
    fontSize: "10px",
    fontWeight: 900,
    color: theme.palette.text.main,
    // color: theme.palette.colors.white.lighter,
  },
  chipOutlined: {
    position: "absolute",
    top: -10,
    right: -1,
    minWidth: "40px",
    height: "25px",
    padding: 1,
    borderTopRightRadius: "16px",
    borderBottomLeftRadius: "16px",
    border: "1px solid ",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: 0.5,
    backgroundColor: theme.palette.background.wallpaper,
  },
  hostsSpacing: {
    display: "flex",
    flexDirection: "column",
    gap: 0.5,
    mb: 3,
  },
  button: {
    position: "absolute",
    bottom: 0,
    left: 0,
    borderBottomRightRadius: "25px",
    borderBottomLeftRadius: "25px",
    width: "100%",
    backgroundColor:
      theme.palette.mode === "dark"
        ? alpha(theme.palette.background.wallpaper, 0.4)
        : theme.palette.colors.white.light,
    color: theme.palette.text.main,
    display: "flex",
    px: 2,
    justifyContent: "space-between",
    borderTop: "1px solid",
    borderTopColor: alpha(theme.palette.colors.gray.light, 0.4),
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0,
  },
  divider: {
    mt: 2,
    mb: 1,
  },
  modalPaper: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "40vw",
    "@media (max-width: 900px)": {
      width: "80vw",
    },
    maxHeight: "70vh",
    overflowY: "auto",
    p: 3,
    borderRadius: 2,
    borderRadius: "16px",
    padding: 3,
    pt: 1,
    display: "flex",
    flexDirection: "column",
    gap: 2,
    position: "relative",
    overflow: "visible",
    minHeight: "150px",
    borderRadius: "25px",
    borderTop: "10px solid",
  },
  modalBox: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    mb: 2,
  },
  modalTitle: {
    position: "absolute",
    top: -10,
    left: 0,
    minWidth: "40px",
    height: "25px",
    padding: 1,
    borderTopLeftRadius: "16px",
    borderBottomRightRadius: "16px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: 0.5,
    p: 1,

    fontSize: "12px",
    fontWeight: 600,
    color: theme.palette.colors.white.lighter,
  },
  modalButton: {
    position: "absolute",
    top: -10,
    right: 0,
    minWidth: "40px",
    height: "25px",

    borderTopRightRadius: "16px",
    borderBottomLeftRadius: "16px",
    border: "1px solid ",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",

    backgroundColor: theme.palette.background.wallpaper,

    ":hover": {
      cursor: "pointer",
    },
  },
  modalContent: {
    display: "flex",
    flexDirection: "column",
    gap: 1,
    overflow: "auto",
    maxHeight: "70vh",
  },
  modalStatusBall: {
    width: "10px",
    height: "10px",
    borderRadius: "50%",
    display: "flex",
    justifyContent: "center",
    alignContent: "center",
    alignItems: "center",
  },
  internalBall: {
    width: "6px",
    height: "6px",
    borderRadius: "50%",
  },
  mensagemNodata: {
    display: "flex",
    alignItems: "center",
    gap: 0.5,
    justifyContent: "center",
    mt: 6,
  },
  containerHost: {
    display: "flex",
    alignItems: "center",
    gap: 1,
  },
  paperSection: {
    bgcolor: theme.palette.background.wallpaper,
    borderRadius: 5,
    p: 2,
    minHeight: 200,
  },
});

export default styles;
